import { createFileRoute } from "@tanstack/react-router";
import "@fontsource/fragment-mono/latin-400.css";
import "@fontsource/special-gothic-expanded-one/latin-400.css";
import { EFFECTS } from "@/components/plumb/effects";
import { Reading } from "@/components/plumb/Reading";
import { COLLABORATORS, FOUNDER, LINKS, depthOf } from "@/components/soad/content";
import { pad } from "@/components/soad/hooks";
import { Page, PageHead } from "@/components/soad/Pages";
import "@/styles/soad.css";

export const Route = createFileRoute("/collaborators")({ component: CollaboratorsPage });

function CollaboratorsPage() {
  return (
    <Page>
      <PageHead label={`collaborators / ${pad(COLLABORATORS.length)}`} lines={["Collaborators"]}>
        <p className="sd-page-lede">genie is founded and run by {FOUNDER}. the work is made with the people below.</p>
      </PageHead>
      {/* One card a person: the picture as the machine reads it, clean under the pointer; a picture of its own is shown as it is. */}
      <ol className="sd-people">
        {COLLABORATORS.map((person, n) => (
          <li key={person.name} className="sd-person">
            <a href={person.url} target="_blank" rel="noreferrer">
              <div className="sd-person-pic">
                <img className="sd-cover" src={person.src} alt="" />
                {person.reading !== undefined && (
                  <Reading
                    className="sd-cover"
                    src={person.src}
                    depth={depthOf(person.src)}
                    effect={EFFECTS[person.reading]}
                  />
                )}
              </div>
              <h2>
                {person.name} <span aria-hidden>↗</span>
              </h2>
              <p className="sd-label">
                <span>{pad(n + 1)}</span>
                <span>{person.note || "collaborator"}</span>
              </p>
            </a>
          </li>
        ))}
      </ol>
      <div className="sd-people-ask">
        <a className="sd-button" href={LINKS.collab}>
          <span>let's collaborate</span>
          <span aria-hidden>→</span>
        </a>
      </div>
    </Page>
  );
}
